import React from 'react';

import * as Misc from './../../misc';
import Analytics from './../../analytics';
import StonesStore from './../../stores/stonesStore';

const stoneLockImage = Misc.localImage('icons/StoneLocked.svg');

export default class StoneItem extends React.Component {
  state = {
    previewVisible: false,
    loadingImage: Misc.localImage('crystal.png'),
    loaded: false
  };
  image = null;

  componentDidMount() {
    this.image = new Image();
    this.image.onload = () => {
      this.setState({loaded: true});
    };
    this.image.src = this.props.stone.ImageUrl;
  }
  componentWillUnmount() {
    this.image.onload = null;
  }

  handleClick = (e) => {
    Analytics.sendClickEvent('stone-selected');
    Analytics.sendClickEvent('stone-selected: ' + this.props.stone.name);
    Misc.ignoreDefault(e);
    this.props.click(this.props.stone, this.props.isLocked);
    StonesStore.setUnsavedChanges();
  };

  handleMagnifyingGlassClick = (e) => {
    Analytics.sendClickEvent('stone-full-view');
    Misc.ignoreDefault(e);
    this.setState({previewVisible: true}, () => {
      $('.full-screen-wrapper').appendTo($('body'));
    });
  };

  handleHidePreview = (e) => {
    Analytics.sendClickEvent('stone-preview-close');
    Misc.ignoreDefault(e);
    $('.full-screen-wrapper').prependTo($(this.container));
    this.setState({previewVisible: false});
  };

  handlePreviewStoneClick = (e) => {
    Misc.ignoreDefault(e);
    Analytics.sendClickEvent('stone-preview');
  };

  render() {
    const s = this.props.stone;
    let style = {};


    let imageUrl = s.ImageUrl;
    let fullImageUrl = s.ImageFullUrl;
    if (s.StoneSupplierStones[0].ImageKey && s.StoneSupplierStones[0].ImageKey.length > 0) {
      fullImageUrl = "https://s3.amazonaws.com/stone_images/sss-" + s.StoneSupplierStones[0].ImageKey;
      imageUrl = "https://s3.amazonaws.com/stone_images/sss-thumbnail-" + s.StoneSupplierStones[0].ImageKey;
    }
    let priceElement = null;
    if (!this.props.isLocked) {
      priceElement = (<p>{s.priceRange}</p>);
    } else {
      priceElement = (<img src={stoneLockImage} width="100%"/>);
    }

    if (this.props.isSelected) {
      style = {
        border: "15px solid #9FC621",
        boxShadow: '8px 8px 0px rgba(0,0,0,0.3)'
      };
    }

    style.backgroundImage = "url('" + imageUrl + "')";

    let bottomInfoClass = "bottomInfo clickable";
    if (this.props.initialStoneIndex !== -1) {
      bottomInfoClass += " initialStone" + (this.props.initialStoneIndex + 1);
    } else {
      bottomInfoClass += " nonInitialStone";
    }

    let previewElement = null;
    if (this.state.previewVisible) {
      previewElement = (
        <div className="full-screen-wrapper" onClick={this.handleHidePreview}>
          <div className="stone-magnified-preview-frame" onClick={this.handlePreviewStoneClick}
               style={{'backgroundImage': "url('" + (fullImageUrl || imageUrl) + "')"}}>
            <div className="stone-magnified-preview-close-button" onClick={this.handleHidePreview}/>
          </div>
        </div>
      );
    }

    // <div className="stone-magnifiying-glass"></div>
    return (
        <div className="step2Cont clickable" data-id={s.Id} style={style}
             onClick={this.handleClick} ref={(node) => this.container = node}>
          {previewElement}
          <div className="stone-magnifiying-glass" onClick={this.handleMagnifyingGlassClick}/>
          <div className="loopInTheCorner pretty-photo-icon" rel="prettyPhoto">
            <i className="fa fa-search" title="View Full Size Image"/>
          </div>

          <div className={bottomInfoClass} onClick={this.handleClick}>
            <p>{s.Name}</p>
            {priceElement}
          </div>
        </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/stones/stoneItem.js